import React from "react";
import { TextField, TextFieldProps } from "@material-ui/core";

// plain text field
const PlainTextField = (props: TextFieldProps) => {
    const withDefaults: TextFieldProps = {
        fullWidth: true,
        margin: "normal",
        variant: "outlined",
        ...props,
    };
    return <TextField {...withDefaults} />;
};

export default PlainTextField;
